import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet"; //Marker, Popup,
import "leaflet/dist/leaflet.css";
import GeoTiffLayer from "./components/GeoTiffLayer";
import "./GeoTiffDemo.css"
import { useContext, useEffect, useState } from "react";
import json from "./new.json";
import { SelectedDataSet } from "./partials/context/SelectedDataset";
import { LayerContext } from "./partials/context/LayerContext";
import L from "leaflet"
import CustomLegend from "./Legend";
import { ChoosenDataSet } from "./partials/context/ChoosenDataSet";
import { NewAddDomain } from "./partials/context/NewAddDomain";
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import { isMobile } from "react-device-detect";
import { DomainContext } from "./partials/context/DomainNameContext";
import Gradient from "javascript-color-gradient";
import { DateContext } from "./partials/context/DateContext";
import { CityContext } from "./partials/context/CityContext";
import { UrlContext } from "./partials/context/UrlContext";
import { ContentContext } from "./partials/context/ContentContext";
import Loading from "./partials/Loading";
import { LoadingContext } from "./partials/context/Loading";
import { LayerAddContext } from "./partials/context/AddedLayer";
import screenfull from 'screenfull';
import { EllipsisRasterLayer,EllipsisVectorLayer } from 'react-leaflet-ellipsis'

// import { CoordinatesControl } from "react-leaflet-coordinates";
// import {ColorRamp} from "colorramp"
export default function App({ locData,center }) {
  const [pallete, setPallete] = useState();
  const [selectedPallete, setSelectedPallete] = useState(null);
  const [palmOilLegendPallete, setPalmOilLegendPallete] = useState(null);
  const { choosenData } = useContext(ChoosenDataSet);
  const { newAddDataSet } = useContext(NewAddDomain);
  const { selectedIdx } = useContext(SelectedDataSet);;
  const [url, setUrl] = useState(null);
  const { selectedDataSet } = useContext(SelectedDataSet);
  const { layer } = useContext(LayerContext);
  const {getLayer}= useContext(LayerContext);
  const [data, setData] = useState();
  const [fly, setFly] = useState(false);
  const [hexAppendString, setHexString] = useState(null);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);
  const [markerData, setMarkerData] = useState(null);
  const [processedMarkerData, setProcessedMarkerData] = useState(null);
  const [isLegendDiscrete, setLegendDiscrete] = useState(false);
  const [noData, setNodata] = useState();
  const { city } = useContext(CityContext);
  const { cityData } = useContext(ContentContext);
  const { getLoading } = useContext(LoadingContext);
  const { loadingOn } = useContext(LoadingContext);
  const [missingData,setMissingData]=useState(false)
  const { getLayerAdd } = useContext(LayerAddContext);
  const { getSelectedDatasetName } = useContext(SelectedDataSet);
  const citation = {
    "Vegetation Index": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "Soil Moisture": ["https://doi:10.5067/5NHC22T9375G","GES DISC"],
    "Water Index": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "Carbon Monoxide (CO)":["https://doi.org/10.5270/S5P-bj3nry0","Copernicus Sentinel-5P(ESA)"],
    "Nitrogen Dioxide (NO2)": ["https://doi.org/10.5270/S5P-9bnp8q8","Copernicus Sentinel-5P(ESA)"],
    "Sulphur Dioxide (SO2)": ["https://doi.org/10.5270/S5P-74eidii","Copernicus Sentinel-5P(ESA)"],
    "Methane (CH4)": ["https://doi.org/10.5270/S5P-3lcdqiv","Copernicus Sentinel-5P(ESA)"],
    "Moisture Index": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "Soil Temperature": ["https://doi.org/10.5067/5NHC22T9375G","GES DISC"],
    "Burned Area Age": ["https://doi.org/10.5067/MODIS/MCD64A1.006","NASA EOSDIS"],
    "Snow Index": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "Formaldehyde (HCHO)": ["https://doi.org/10.5270/S5P-vg1i7t0","Copernicus Sentinel-5P(ESA)"],
    "Palm Oil Plantation Types": ["https://zenodo.org/record/4473715","Biopama programme"],
    "Gender Ratio": ["https://doi.org/10.1038/sdata.2015.45","Worldpop.org"],
    "Sea Surface Temperature": ["https://doi.org/10.7289/V5SQ8XB5","NOAA"],
    "Population": ["https://doi.org/10.1038/sdata.2015.45","Worldpop.org"],
    "Population (>35y old)": ["https://doi.org/10.1038/sdata.2015.45","Worldpop.org"],
    "Population (<35y old)": ["https://doi.org/10.1038/sdata.2015.45","Worldpop.org"],
    "Specific Humidity": ["https://doi.org/10.5067/5NHC22T9375G","GES DISC"],
    "Surface Pressure": ["https://doi.org/10.5067/5NHC22T9375G","GES DISC"],
    "Land Surface Temperature": ["https://doi.org/10.5067/MODIS/MOD11A1.006","NASA EOSDIS"],
    "Fire Radiative Power": ["https://doi.org/10.5067/MODIS/MOD14A1.006","NASA EOSDIS"],
    "Night Lights": ["https://eogdata.mines.edu/products/vnl/","VIIRS"],
    "Power Plant Locations": ["https://resourcewatch.org/","Resource watch"],
    "Satellite True Color (10m)": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "Satellite False Color (10m)": ["https://doi.org/10.5270/S2_-znk9xsj","Copernicus Sentinel-2(ESA)"],
    "UV Aerosol Index": ["https://doi.org/10.5270/S5P-j7aj4gr","Copernicus Sentinel-5P(ESA)"],
    "Ozone (O3)":["https://doi.org/10.5270/S5P-j7l9xvd","Copernicus Sentinel-5P(ESA)"]
  }
  useEffect(() => {
    // console.log("innnnn");
    // console.log(selectedIdx);
    if (newAddDataSet == undefined && choosenData && selectedIdx && selectedIdx.length > 0) {
      // console.log(choosenData[selectedIdx[0]].name);
    }
    
    if (newAddDataSet == undefined && choosenData && selectedIdx && selectedIdx.length > 0) {
      getSelectedDatasetName(choosenData[selectedIdx[0]].name)
      setSelectedPallete(choosenData[selectedIdx[0]].name)
    }
    else if (newAddDataSet && selectedIdx && selectedIdx.length > 0) {
      getSelectedDatasetName(newAddDataSet[selectedIdx[0]].name)
      setSelectedPallete(newAddDataSet[selectedIdx[0]].name);
    }
    if (selectedDataSet == undefined) {
      setSelectedPallete(null);
    }
    setData(selectedDataSet);
    // setUrl(null);
    
  }, [selectedIdx]);
  // console.log(selectedIdx);
  useEffect(() => {
    setData(selectedDataSet);
    // setUrl(null);
    
  }, [selectedDataSet])
  useEffect(() => {
    setFly(true);
  },[city])
  useEffect(() => {
    // console.log(selectedPallete);
    // console.log(data);
    // console.log("inside selected palette")
    if (data) {
      // console.log(data)
      if (data && data.image_url.includes("ndwi")==true) {
        //  console.log("in waterindex")
        const gradientArray1 = new Gradient()
          .setColorGradient("#008000", "#FFFFFF", "#0000CC")
          .setMidpoint(10)
          .getColors();
        setPallete(gradientArray1);
        setUrl(data.image_url);
        setNodata(data.no_data_value);
        setLegendDiscrete(false);
        setHexString("");
      }
      else if (data && data.image_url.includes("ndmi") == true) {
        const gradientArray2 = new Gradient()
            .setColorGradient("#000000", "#FF0000", "#FFFF00", "#0000FF")
            .setMidpoint(20)
            .getColors();
        setPallete(gradientArray2);
        setUrl(data.image_url);
        setNodata(data.no_data_value);
        setLegendDiscrete(false);
        setHexString("");
      }
      else if (data && data.image_url.includes("ndwi") == false) {
          //    if (selectedPallete == "Moisture Index") {
          // const gradientArray2 = new Gradient()
          //   .setColorGradient("#000000", "#FF0000", "#FFFF00", "#0000FF")
          //   .setMidpoint(20)
          //   .getColors();
          //   setPallete(gradientArray2);
          //   setHexString("");
          //   } else {
        setPallete(data.palette);
        var pallete1 = data.palette;
        if (isHexColor(pallete1[0])) {
          setHexString("#");
        } else {
          setHexString("");
        }

        // console.log("not water index")
        setUrl(data.image_url);
        // setPallete(data.palette);
        setNodata(data.no_data_value)

        if (data && data.image_url.includes("power_plant_database") === true) {
          // console.log("inside palette")
          setLegendDiscrete(true);

          if (isHexColor(pallete1.Coal)) {
            setHexString("#");
          } else {
            setHexString("");
          }
          // let url2 = "http://13.126.19.239:8000/static/power_plant_db.csv" // Replace with image_url later
          // Fetch the csv and set the data in markerData state
          // console.log(data.image_url);
          readCsv(data.image_url)
          // Power plant DB does not have any min, max value
        } else {
          setLegendDiscrete(false);
        }

        if (data && data.image_url.includes("palm_plantation") === true) {
          // Change the pallete and no data value for this dataset
          let noDataValue = [0, 3]
          let newPallete = {
            "Industrial": "ff0000",
            "Small-Holder": "ef00ff",
          }
          // Change min and max value
          data.min = 1;
          data.max = 2;
          setPalmOilLegendPallete(newPallete);
          let palleteNew = ["ff0000", "ef00ff"];
          setPallete(palleteNew);
          setHexString("#");
          setLegendDiscrete(true);
          // Update the no data value
          setNodata(noDataValue);
        }
      }

      setMinValue(data.min=="none"?data.min:+data.min);
      setMaxValue(data.max=="none"?data.max:+data.max);
      // getPrevUrl(data.image_url);
      setFly(false)
      getLayer(false);
      getLoading(true);
      setMissingData(false)
    }
  }, [data])
  // console.log(selectedDataSet);
  // console.log(prevUrl)
  // console.log(loadingOn);
  useEffect(() => {
    // console.log("marker data is set")
    if (selectedPallete && selectedPallete === "Power Plant Locations") {
      var markerInfo = [];
      markerData.forEach(element => {
        let temp = {}
        temp['lat'] = element["latitude"]
        temp['lng'] = element["longitude"]
        temp['type'] = element["fuel1"]
        temp['color'] = pallete[element["fuel1"]]
        markerInfo.push(temp);
      })

      setProcessedMarkerData(markerInfo)
    }
  }, [markerData])
  function FlytoPosition({val}) {
    const map = useMap();
    map.flyTo(val,!isMobile?12:11
      // { Animation: true }
    );
  }
  function convertPixelValueForNDMI(val) {
    var vmin = -0.8;
    var vmax = 0.8;
    var dv = vmax - vmin;

    var r = 0.0;
    var g = 0.0;
    var b = 0.0;

    var v = val;
    if (v < vmin) {
      v = vmin;
    }
    if (v > vmax) {
      v = vmax;
    }

    var l1 = 0.35;
    var l2 = 0.48;
    var l3 = 0.52;
    var l4 = 0.65;

    var level1 = (vmin + l1 * dv);
    var level2 = (vmin + l2 * dv);
    var level3 = (vmin + l3 * dv);
    var level4 = (vmin + l4 * dv);
    if (v < level1) {
      r = 0.5 + (v - vmin) / (level1 - vmin) / 2;
    } else if (v < level2) {
      r = 1;
      g = (v - level1) / (level2 - level1);
      b = 0;
    } else if (v < level3) {
      r = 1 + (level2 - v) / (level3 - level2);
      g = 1;
      b = (v - level2) / (level3 - level2);
    } else if (v < level4) {
      r = 0;
      g = 1 + (level3 - v) / (level4 - level3);
      b = 1;
    } else {
      b = 1.0 + (level4 - v) / (vmax - level4) / 2;
    }

    // Convert to rgba format
    r *= 255;
    g *= 255;
    b *= 255;

    return [r, g, b];
  }
  function convertPixelValueForNDWI(pixelValue) {
    // const x = ColorRamp.getColorRamp(['green', 'white'], 3);
    // console.log(x)
    // For pixel values b/w -1 to 0, return pixel value as it is, Color Range: #008000 (Green) to #FFFFFF (White)
    if (pixelValue >= -1 && pixelValue <= 0) {
      return pixelValue;
    }
    // For pixel values b/w 0 to 1, we push the value towards the 1 by taking double square root, Color Range: #FFFFFF (White) to #0000CC (Blue)
    if (pixelValue > 0 && pixelValue <= 1) {
      return Math.sqrt(Math.sqrt(Math.sqrt(pixelValue)))
    }
  }
  const zoom = 3;

  const rgbMaxVal = maxValue;
  const ndviMinVal = minValue
  const ndviMaxVal = maxValue
  const options = {
    pixelValuesToColorFn: (values) => {
      if (selectedPallete == "Satellite False Color (10m)" || selectedPallete == "Satellite True Color (10m)") {
        const nir = (values[0] / rgbMaxVal) * 255;
        const nig = (values[1] / rgbMaxVal) * 255;
        const nib = (values[2] / rgbMaxVal) * 255;
        
        if (nir === 0) return;
        // console.log("nir:", nir);
        const r = nir;
        const g = nig;
        const b = nib;
        // console.log(`rgba(${r},${g},${b}, 1)`)
        return `rgba(${r},${g},${b}, 1)`;
      }
    
      // For NDVI.tif 
      //make cloud coverage as transparent
      else {
         if (selectedPallete === "Moisture Index") {
          let rgbColor = convertPixelValueForNDMI(values[0]);
          // console.log(rgbColor);
          return `rgba(${rgbColor[0]},${rgbColor[1]},${rgbColor[2]}, 1)`;
        }
        if (selectedPallete === "Water Index") {
          let modifiedPixel = convertPixelValueForNDWI(values[0]);
          values[0] = modifiedPixel
        }

        if (Array.isArray(noData)) {
          // If no data value is an array, check if pixel value is among the no data value, if yes then mark it as transparent
          if (noData.indexOf(values[0]) >= 0) {
            return "#ff000000"
          }
        } else {
          // If noData value is not an array then directly compare it
          if (values[0] === noData) {
            return "#ff000000"
          }
        }

        let tweakedValue = (values[0] - ndviMinVal) / (ndviMaxVal - ndviMinVal);
        
        if (hexAppendString) {
          return hexAppendString + getFromBucket(tweakedValue, values[0]);
        }

        return getFromBucket(tweakedValue, values[0]);
      }
    },
    resolution: !isMobile?512:128,
    opacity: 0.75,
  };
  function getFromBucket(num, originalPixelValue) {

    if (originalPixelValue <= ndviMinVal) {
      return pallete[0];
    }

    if (originalPixelValue > ndviMaxVal) {
      return pallete[pallete.length - 1];
    }

    var index = Math.floor(num * pallete.length);

    if (index >= pallete.length) {
      index = pallete.length - 1
    }

    if (index < 0) {
      index = 0;
    }

    return pallete[index];
  }

  function isHexColor(hex) {
    return typeof hex === 'string'
      && hex.length === 6
      && !isNaN(Number('0x' + hex))
  }

  const readCsv = async (url) => {
    // console.log(url);
    try {
      //read .csv file on a server
      const target = url;

      //target can also be api with req.query
      //get csv-structure-response from a server 
      //const target = `https://SOME_DOMAIN.com/api/data/log_csv?[QUERY]`;

      const res = await fetch(target, {
        method: 'get',
        // headers: {
        //   'content-type': 'text/csv;charset=UTF-8',
        //   //in case you need authorisation
        //   //'Authorization': 'Bearer ' + [TOKEN] //or what you like
        // }
      })
      if (res.status === 200) {
        const data = await res.text();
        const csv = require('csvtojson')
        csv()
          .fromString(data)
          .then((jsonObj) => {
            // console.log(jsonObj);
            if (jsonObj.length == 0) {
              setMissingData(true);
              // getLoading(true);
              getLayerAdd(true)
            }
            else {
              setMissingData(false);
              getLayerAdd(true)
              // getLoading(false);
            }
            setMarkerData(jsonObj);
            // console.log(jsonObj)
            // return jsonObj;
          })
        
      } else {
        // console.log(`Error code ${res.status}`);
      }
    } catch (err) {
      // console.log(err)
    }
  }
  // console.log(layer);
  // console.log(selectedDataSet);
  // console.log(url)
  // console.log(selectedPallete)
  // const mapDiv = document.getElementById("map");
  // mapDiv.addEventListener("click", () => {
  //   if (screenfull.isEnabled) {
  //     screenfull.toggle(mapDiv);
  //   }
  // })
  return (
    <div className={`${!isMobile ? "map-container-div" : "map-container-div-mob"}`}>
      
       <MapContainer id="map" center={center} zoom={zoom} scrollWheelZoom={true} dragging={!L.Browser.mobile} gestureHandling={isMobile?true:false} >
        {/* <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
        />
        
        {url!=null && <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
          zIndex={10}
          
        />} */}
        <TileLayer
          noWrap={true}
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
        />
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
          zIndex={10}
          
        />
        {selectedDataSet && selectedPallete!="Power Plant Locations" && selectedDataSet.layer_id != "none" && selectedDataSet.timestamp_id != "none" && <EllipsisRasterLayer
           styleId={selectedDataSet.style_id}
           pathId={selectedDataSet.layer_id}
           timestampId = {selectedDataSet.timestamp_id}
           token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1dWlkIjoiMzgzNDBhYTEtNTJjMS00Zjg3LThjYTItYzgyYjI5NDU2YmM5IiwiaWF0IjoxNjg2NTc1NTI1LCJleHAiOjE2ODY2NjE5MjV9.lYKKpCken3WGoOcfIW7lkX81V5PRf_x6JgbHfQRSGI0"
        />}
        {selectedDataSet && selectedPallete=="Power Plant Locations" && <EllipsisVectorLayer pathId={selectedDataSet.layer_id}
           timestampId = {selectedDataSet.timestamp_id} />}
        
        {selectedDataSet != undefined && (selectedPallete != "Satellite True Color (10m)" && selectedPallete != "Satellite False Color (10m)") && selectedPallete != "Power Plant Locations" && selectedPallete != "Palm Oil Plantation Types" && <CustomLegend zIndex={401} pallete={pallete} datasetName={selectedPallete} isLegendDiscrete={isLegendDiscrete} hexAppendString={hexAppendString} max={maxValue} min={minValue} />}
        {selectedDataSet!=undefined && selectedPallete=="Power Plant Locations" && <CustomLegend zIndex={401} pallete={pallete} isLegendDiscrete={isLegendDiscrete} hexAppendString={hexAppendString} max={maxValue} min={minValue} datasetName={selectedPallete} />}
        {/* Custom Legend for Palm Oil Plantation Types */}
        {selectedDataSet != undefined && selectedPallete == "Palm Oil Plantation Types" && <CustomLegend zIndex={401} pallete={palmOilLegendPallete} isLegendDiscrete={isLegendDiscrete} hexAppendString={hexAppendString} max={maxValue} min={minValue} datasetName={selectedPallete} dataset={selectedDataSet} />}
        {fly == true && cityData && <FlytoPosition val={[cityData.latitude,cityData.longitude]}  />}
        {/* {selectedPallete != "Power Plant Locations" && layer == true && <GeoTiffLayer url={url} options={options} />} */}
        {selectedPallete == "Power Plant Locations" && processedMarkerData != null && processedMarkerData.map((element, index) => {
          // console.log(element);
          var iconSettings = {
            mapIconUrl: '<svg version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149 178"><circle fill="{mapIconColor}" cx="74" cy="75" r="40" opacity="0.8"/></svg>',
            mapIconColor: "#" + element.color,
            pinInnerCircleRadius: 48
          };

          // icon normal state
          var divIcon = L.divIcon({
            className: "leaflet-data-marker",
            html: L.Util.template(iconSettings.mapIconUrl, iconSettings), //.replace('#','%23'),
            iconAnchor: [12, 32],
            iconSize: [25, 30],
            popupAnchor: [0, -28]
          });

          return < Marker position={[element.lat, element.lng]} key={index} icon={divIcon} ></Marker>

        })}
        {/* <CoordinatesControl/> */}
        {loadingOn==true && selectedDataSet && selectedPallete!="Power Plant Locations" && <Loading type={ "bars"} color={"#000000"}  />}
        {missingData == true && selectedDataSet && !isMobile ? <h2 className="missing">There is no power plant in this location</h2> :
        missingData==true && selectedDataSet && isMobile&& <p className="missing-mob">There is no power plant in this location</p>}
      </MapContainer>
      <span className={`${!isMobile?"copy-right":"copy-right-mob"}`}><a href="https://skyserve.ai" target="_blank">EarthSIGHTS by SkyServe</a> | ©    <a style={{color:"rgb(0, 183, 255)"}} href="http://osm.org/copyright" target="_blank">OpenStreetMap </a>
        <span style={{ color: "white" }}>contributors</span>
        {selectedPallete && <span className={`${!isMobile?"citation":"citation-mob"}`}>| © <a style={{color:"rgb(0, 183, 255)"}} href={citation[selectedPallete][0]} target="_blank">{citation[selectedPallete][1]}</a></span>}
      </span>
      </div>
  );
}


        
